import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Sc4MessageCheckerState } from './sc4-message-checker.state';
import { Sc4ErrorMessageListCheck, Sc4ErrorMessageListInitialState } from './sc4-message-checker.actions';
import { DataQualityErrorMessage, MessageCheckerFacade } from '../models/message-checker.model';

@Injectable({ providedIn: 'root' })
export class Sc4MessageCheckerFacade implements MessageCheckerFacade {
  errorMessages$: Observable<DataQualityErrorMessage> = this.store.select(
    Sc4MessageCheckerState.getSc4ErrorMessageList,
  );
  loaded$: Observable<boolean> = this.store.select(Sc4MessageCheckerState.getLoaded);

  constructor(private store: Store) {}

  checkMessage(message: string): void {
    this.store.dispatch(new Sc4ErrorMessageListCheck(message));
  }

  setInitialState(): void {
    this.store.dispatch(new Sc4ErrorMessageListInitialState());
  }
}
